export default function(){var e=new Date,t=e.getFullYear(),a=e.getMonth(),r=e.getDate(),n=new Date(0);return n.setFullYear(t,a,r+1),n.setHours(0,0,0,0),n}
